import initialState from './partnerAgreementInitialState';
import actions from './partnerAgreementAction';
import mutations from './partnerAgreementMutation';

const getters = {
  totalDeposit: (state) => {
    const {
      agreement,
    } = state;
    let total = 0;
    if (agreement) {
      total = agreement.agreementOrders.reduce((acc, o) => {
        const {
          agreementOrderLines,
          subscriptionTax,
        } = o;
        let t = acc;
        t += agreementOrderLines[0].total;
        if (subscriptionTax) {
          t += subscriptionTax;
        }
        return t;
      }, 0);
    }
    return total;
  },
};

const partnerAgreementModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default partnerAgreementModule;
